"use strict";Object.defineProperty(exports, "__esModule", {value: true});var _react = require('react');

var _conversation = require('shared/selectors/conversation');
var _hooks = require('web/services/hooks');

const updateHref = (id, href) => {
  (document.getElementById(id) ).href = href
}

const setAttention = () => {
  updateHref('apple-touch-icon', 'assets/images/favicons/alert-apple-touch-icon.png')
  updateHref('favicon-32x32', 'assets/images/favicons/alert-favicon-32x32.png')
  updateHref('favicon-16x16', 'assets/images/favicons/alert-favicon-16x16.png')
  updateHref('favicon', 'assets/images/favicons/alert-favicon.ico')
  updateHref('favicon-manifest', 'assets/images/favicons/alert-manifest.json')
}

const unsetAttention = () => {
  updateHref('apple-touch-icon', 'assets/images/favicons/apple-touch-icon.png')
  updateHref('favicon-32x32', 'assets/images/favicons/favicon-32x32.png')
  updateHref('favicon-16x16', 'assets/images/favicons/favicon-16x16.png')
  updateHref('favicon', 'assets/images/favicons/favicon.ico')
  updateHref('favicon-manifest', 'assets/images/favicons/manifest.json')
}

// Swaps the favicons when the inbox alert state changes. Like the former
// PureComponent's componentDidUpdate, it does nothing on mount and only acts
// when `attention` changes. memo keeps the former PureComponent bailout.
const Notifications = _react.memo.call(void 0, function Notifications () {
  const attention = _hooks.useAppSelector.call(void 0, _conversation.selectInboxHasAlert)
  const prevAttentionRef = _react.useRef.call(void 0, attention)

  _react.useEffect.call(void 0, () => {
    if (prevAttentionRef.current === attention) return
    prevAttentionRef.current = attention
    if (attention) setAttention()
    else unsetAttention()
  }, [attention])

  return null
})

exports. default = Notifications
